import { Pipe, PipeTransform } from '@angular/core';
import { Attachment } from '../models/submissions/attachment';

/** Resolves an attachment's first presigned link, e.g. for previewUrl/thumbnailUrl bindings. */
@Pipe({
  name: 'presignedUrl',
  standalone: true
})
export class PresignedUrlPipe implements PipeTransform {
  public transform(attachment: Attachment | null | undefined): string | null {
    return attachment?.links?.[0]?.presignedUrl ?? null;
  }
}
